import { render, staticRenderFns } from "./iconClose.vue?vue&type=template&id=0faadf5c&"
import script from "./iconClose.vue?vue&type=script&lang=js&"
export * from "./iconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports